import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import styleObj from './style.module.scss'
import { getPageData } from '../../assets/js/getData'
// import Dialog from '../dialog'

let navList = [
  {
    name: '南京站',
    path: '/',
  },
  {
    name: '上海站',
    path: '/shanghai',
  },
  {
    name: '重庆站',
    path: '/chongqing',
  },
  {
    name: '长沙站',
    path: '/changsha',
  },
  {
    name: '西安站',
    path: '/xian',
  },
  {
    name: '北京站',
    path: '/beijing',
  },
  // {
  //   name: '深圳站',
  //   path: '/shenzhen',
  // },
]

// function getStatus(status) {
//   switch (status) {
//     case 0:
//       return '未开始'
//     case 1:
//       return '报名中'
//     default:
//       return ''
//   }
// }

function getDateTime(timeStr) {
  return new Date(timeStr).getTime()
}

function getCommonTime(time) {
  let issafariBrowser =
    /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  return issafariBrowser ? time.replace(/-/g, '/') : time
}

export default class MyNav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: navList,
    }
    this.preventClick = this.preventClick.bind(this)
  }
  render() {
    let { list } = this.state
    return (
      <div className={styleObj['nav-wrap']}>
        <div className={styleObj['nav-pic']}></div>
        <div className={styleObj['nav']}>
          {list.map((item) => (
            <NavLink
              key={item.path}
              exact
              to={item.path}
              className={item.status === 0 ? styleObj['will-open'] : ''}
              activeClassName={styleObj['on']}
              onClick={(e) => {
                this.preventClick(e, item.isPrevent)
              }}
            >
              <p>{item.name}</p>
              {
                // <p className={styleObj['status']}>({getStatus(item.status)})</p>
                <p className={styleObj['status']}>
                  {item.timeEnd ? item.timeEnd.split(' ')[0] : ''}
                </p>
              }
            </NavLink>
          ))}
        </div>
      </div>
    )
  }
  componentDidMount() {
    getPageData().then((data) => {
      const nowTime = new Date().getTime()
      navList.forEach((x) => {
        data.forEach((y) => {
          if (x.name.indexOf(y.name) > -1) {
            x.timeStart = getCommonTime(y.form.timeStart)
            x.timeEnd = getCommonTime(y.form.timeEnd)

            if (
              !x.timeStart ||
              !x.timeEnd ||
              nowTime < getDateTime(x.timeStart)
            ) {
              x.isPrevent = true
              x.status = 0
            } else if (
              nowTime > getDateTime(x.timeStart) &&
              nowTime <= getDateTime(x.timeEnd)
            ) {
              x.isPrevent = false
              x.status = 1
            } else if (nowTime > getDateTime(x.timeEnd)) {
              x.isPrevent = false
              x.status = 2
            }
          }
        })
      })
      console.log(navList)
      this.setState({
        list: navList,
      })
    })
  }
  preventClick(e, isPrevent) {
    console.log('isPrevent: ', isPrevent)

    if (isPrevent) {
      // Dialog('活动尚未开始，敬请期待~').show()
      e.preventDefault()
      // window.open('http://www.jiguo.com/event/index/3706.html','__target')
    }
  }
}
